import {Component, OnDestroy} from '@angular/core';
import {ClientErrorReporterService} from './services/client-error-reporter.service';
import {ScrollPositionService} from './services/scroll-position.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnDestroy {
  title = 'APG';

  constructor(
    private scrollPositionService: ScrollPositionService,
    private clientErrorReporter: ClientErrorReporterService,
    // afs: AngularFirestore,
  ) {
    this.scrollPositionService.initialize();
    this.clientErrorReporter.initialize();
    // afs.firestore.enablePersistence({
    //   experimentalForceOwningTab: true,
    //   synchronizeTabs: false
    // })
    //   .then(() => console.log(`Offline persistence initiated`))
    //   .catch(err => console.error(`Offline persistence failed`, err));
  }
  // addToHomeScreen() {
  //   // hide our user interface that shows our A2HS button
  //   this.showButton = false;
  //   // Show the prompt
  //   this.deferredPrompt.prompt();
  //   // Wait for the user to respond to the prompt
  //   this.deferredPrompt.userChoice.then((choiceResult) => {
  //     if (choiceResult.outcome === 'accepted') {
  //       console.log('User accepted the A2HS prompt');
  //     } else {
  //       console.log('User dismissed the A2HS prompt');
  //     }
  //     this.deferredPrompt = null;
  //   });
  // }

  ngOnDestroy() {
    this.scrollPositionService.destroy();
  }
}
